import { render } from "./multi-checkbox.vue?vue&type=template&id=40541bba"
import script from "./multi-checkbox.vue?vue&type=script&lang=js"
export * from "./multi-checkbox.vue?vue&type=script&lang=js"

import exportComponent from "/home/michael/share/nfs-share/eschenbach-eyewear/web/wp-content/plugins/eon-vue-filter/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__